
  export default {
    layout: 'error-page',
     head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        title:"Forgot Password",
        form: {
          email: null,
        },
        //Form error variables
        errors: {
          formError: null,
          formErrMsg: "Opps! Something went wrong, please try again."
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false,
          successMsg: 'Please Check your email.'
        }
      }
    },
    // Check login token
    mounted() {
      if (localStorage.getItem("authToken")) {
        //this.$router.push({
//          path: '/'
//        })
      }
    },
    methods: {
      // To clear the submit error message
      clearFormErrMsg() {
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
      },
      // Validate and Submit form data to LOGIN
      sendMessage() {
        // Clear all submit errors before API call
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
        // Validate all fields for making the API call, throw error and not call API if validation errors are present
        this.$refs.forgotPasswordForm.validate().then((success) => {
          if (!success) {
            // run your error code here
            this.errors.formError = "One or more incorrect fields present, please fix.";
          } else {
            // If Valid form
            // Create url encoded formData instance to pass the data to the API
            var formData = new URLSearchParams();
            formData.append("email", this.form.email.trim());
            // Add header for the API
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
            this.submit.loading = true;
            // AXIOS api call to add SIGNIN api
            this.$axios
              .post("/auth/forgotPassword", formData, {
                headers: headers
              })
              .then(response => {
                this.submit.success = true
                this.submit.errored = false
                let value = this.getCryptKey(response.data);
                if(value.success && value.success == true){
                  this.submit.successMsg = value.message;
                  this.form.email = null;
                  this.$refs.forgotPasswordForm.reset();
                }
                else{
                    this.errors.formErrMsg = value.message
                }
              })
              .catch(error => {
                if (error.response){
                  let value = this.getCryptKey(error.response.data)
                  this.errors.formErrMsg = value.message
                }
                  
                this.submit.success = false
                this.submit.errored = true
              })
              .finally(() => {
                this.submit.loading = false
              });
          }
        });
      },
    }
  }

